<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.activities_index,
                    },
                    {
                        name: subject.name,
                        href: meta.links.subject_tag_scores_index,
                    },
                    {
                        name: block.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <ContentBlockScores :content-block="block" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import ContentBlockScores from '@/components/ContentBlockScores.vue';

export default {
    components: {
        PanelPage,
        ContentBlockScores,
    },
    layout: Layout,
    name: 'Show',
    props: ['block', 'subject', 'meta'],
};
</script>
